import {Component} from "@angular/core";

@Component({
    selector: 'app-information',
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.scss'],
    standalone: false
})
export class InformationComponent {}
